import previewContainerStyle from "./PreviewContainer.module.scss";
export const PreviewContainer = (props: { children: React.ReactNode  }) => {
  return (
    <div className={previewContainerStyle.container}>
      <p className={previewContainerStyle.textCenter}>Preview</p>
      {props.children}
    </div>
  );
};
